import Snowfall from 'react-snowfall'
import { useAppSelector } from '../../store/Hooks'
import ReactDOM from 'react-dom'
import { useEffect, useState } from 'react'

interface SnowfallEffectProps {
    snowflakeCount?: number
    speed?: [number, number]
    opacity?: [number, number]
}

interface SnowOverlayProps {
    position: 'left' | 'right'
    image: string
}

const ChristmasDecoration = () => {
    return (
        <>
            <SnowfallEffect opacity={[0.6, 1]} snowflakeCount={150} speed={[1, 2]} />
            <SnowOverlay position='right' image='/decorations/top-right-snow.png' />
            <AppendSantaClaus />
        </>
    )
}

export const SnowfallEffect = ({ snowflakeCount, speed, opacity }: SnowfallEffectProps) => {
    const route = useAppSelector(s => s.session.currentRoute)
    const [shouldRender, setShouldRender] = useState(false)

    useEffect(() => {
        if (route === 'overview') setShouldRender(true)
        else setShouldRender(false)
    }, [route])

    if (!shouldRender) return null

    return (
        <Snowfall
            snowflakeCount={snowflakeCount}
            speed={speed}
            opacity={opacity}
        />
    )
}

export const SnowOverlay = ({ position, image }: SnowOverlayProps) => {
    const route = useAppSelector(s => s.session.currentRoute)
    const [ref, setRef] = useState<HTMLDivElement>()

    useEffect(() => {
        setRef(document.querySelector('.spotlight-container.spotlight-closed') as any)
    }, [route])

    if (route !== 'overview') return null
    if (ref) {
        // This locks it at the first render. If you move or change the window size then it gets messed up...
        const { left, top, width, height } = ref.getBoundingClientRect()
        return (
            <div className='snow-overlay' style={{ left, top, width, height, pointerEvents: 'none' }}>
                <div
                    className={`snow-overlay snow-overlay-${position}`}
                    style={{ backgroundImage: `url(${image})` }}
                />
            </div>
        )
    } else return null
}

export const SantaClaus = () => {
    return (
        <div style={{ position: 'fixed', bottom: 0, left: '1%', transform: 'translateY(90%)' }} className='santa'>
            <img src='/decorations/santa-icon.svg' width='60%' height='100%' />
        </div>
    )
}

export const AppendSantaClaus = () => {
    const route = useAppSelector(s => s.session.currentRoute)
    const [santaHook, setSantaHook] = useState<HTMLElement | null>(null)

    useEffect(() => {
        setSantaHook(document.querySelector('.base-layout') as HTMLElement | null)
    }, [route])

    if (!santaHook) return null
    if (route !== 'overview') return null

    return ReactDOM.createPortal(<SantaClaus />, santaHook)
}

export default ChristmasDecoration
